import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function InviteAcceptPage() {
    const { teamId } = useParams(); // URL에서 팀 ID 추출
    const navigate = useNavigate();
    const [team, setTeam] = useState(null);

    // ✅ 환경변수 선언 (Vercel 설정 연동용)
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

    // 현재 로그인한 사용자 정보
    const storedUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const userName = storedUser.name; // ✅ 로그인 여부 확인을 위해 초기값 삭제

    // ✅ [추가] 강제 로그인 로직: 로그인 정보가 없으면 로그인 페이지로 이동
    useEffect(() => {
        if (!userName) {
            alert("로그인 후 이용해 주세요.");
            navigate('/'); // App.js에 정의된 로그인 페이지 경로
        }
    }, [userName, navigate]);

    useEffect(() => {
        const allTeams = JSON.parse(localStorage.getItem('allTeams') || '[]');
        const foundTeam = allTeams.find(t => String(t.id) === String(teamId));

        if (foundTeam) {
            setTeam(foundTeam);
        } else {
            alert("존재하지 않거나 만료된 초대 링크입니다.");
            navigate('/main');
        }
    }, [teamId, navigate]);

    const handleAccept = () => {
        const allTeams = JSON.parse(localStorage.getItem('allTeams') || '[]');

        const updatedTeams = allTeams.map(t => {
            if (String(t.id) === String(teamId)) {
                // 이미 팀원인지 확인
                const isAlreadyMember = t.members.some(m => m.name === userName);
                if (isAlreadyMember) return t;

                // 새 팀원으로 추가
                const newMember = {
                    id: Date.now(),
                    name: userName,
                    role: "팀원",
                    isLeader: false,
                    task: "새로 합류함",
                    todo: [],
                    completed: [],
                    contribution: 0
                };
                return { ...t, members: [...t.members, newMember] };
            }
            return t;
        });

        localStorage.setItem('allTeams', JSON.stringify(updatedTeams));
        alert(`${team.name} 팀에 합류되었습니다! 🎉`);
        navigate('/team-project'); // 팀 목록 페이지로 이동
    };

    if (!team || !userName) return null; // ✅ 로그인하지 않았거나 팀 정보가 없으면 화면을 그리지 않음

    return (
        <div style={styles.overlay}>
            <div style={styles.card}>
                <h2 style={styles.title}>📢 팀플 초대장이 도착했습니다!</h2>
                <div style={styles.infoBox}>
                    <p style={styles.teamName}>팀명: <strong>{team.name}</strong></p>
                    <p style={styles.projectTitle}>주제: {team.projectTitle}</p>
                </div>
                <p style={styles.desc}><strong>{userName}</strong> 님, 이 팀의 일원으로 합류하시겠습니까?</p>
                <div style={styles.btnGroup}>
                    <button style={styles.acceptBtn} onClick={handleAccept}>수락하고 시작하기</button>
                    <button style={styles.cancelBtn} onClick={() => navigate('/main')}>거절하기</button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: { position: 'fixed', inset: 0, backgroundColor: '#F1F5F9', display: 'flex', justifyContent: 'center', alignItems: 'center' },
    card: { backgroundColor: '#fff', padding: '40px', borderRadius: '30px', boxShadow: '0 20px 50px rgba(0,0,0,0.1)', textAlign: 'center', width: '450px' },
    title: { fontSize: '24px', fontWeight: '1000', marginBottom: '20px', color: '#4A90E2' },
    infoBox: { backgroundColor: '#F8FAFC', padding: '20px', borderRadius: '20px', marginBottom: '20px', border: '2px solid #E2E8F0' },
    teamName: { fontSize: '20px', margin: '0 0 10px 0' },
    projectTitle: { fontSize: '16px', color: '#64748B', margin: 0 },
    desc: { fontSize: '16px', fontWeight: '700', marginBottom: '30px' },
    btnGroup: { display: 'flex', gap: '15px' },
    acceptBtn: { flex: 1, padding: '15px', backgroundColor: '#4A90E2', color: '#fff', border: 'none', borderRadius: '15px', fontWeight: '1000', cursor: 'pointer' },
    cancelBtn: { flex: 1, padding: '15px', backgroundColor: '#E2E8F0', color: '#475569', border: 'none', borderRadius: '15px', fontWeight: '1000', cursor: 'pointer' }
};

export default InviteAcceptPage;